__webpack_require__.p = "/Hero_Arena/";